import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MDTagComponent } from '@melodic-ui/components';

@Component({
	selector: 'lb-invoice-pay-period-cell',
	standalone: true,
	imports: [CommonModule, MDTagComponent],
	templateUrl: './invoice-pay-period-cell.component.html',
	styleUrl: './invoice-pay-period-cell.component.scss'
})
export class InvoicePayPeriodCellComponent {
	payPeriod = input.required<string>();
	isCurrent = input.required<boolean>();
}
